// extracted by mini-css-extract-plugin
export default {"link":"styles_link__+4y5o","small":"styles_small__BVMLe"};